<template>
    <div class="float-left mr-1">
        <span class="text-warning">
            <i
                class="fa fa-usd fa-lg icon-button"
                title="Saldo Projeto/Ação"
                @click.stop="obterSaldoProjetoAcao()"
            ></i>
        </span>
    </div>
</template>

<script>
import DotacoesServicos from './DotacoesServicos'

export default {
    props: {
        rateio: {
            type: Object,
            default: () => ({})
        },

        dataMovimento: {
            type: String
        }
    },

    data() {
        return {
            saldoProjetoAcao: 0
        }
    },

    methods: {
        obterSaldoProjetoAcao() {
            this.$store.dispatch('addRequest')
            let hoje = new Date()
            let ano = hoje.getFullYear()
            let mes = hoje.getMonth()
            if (this.dataMovimento) {
                let dtMovimento = this.$moment(this.dataMovimento, 'DD/MM/YYYY')
                ano = dtMovimento.year()
                mes = dtMovimento.month()
            }
            DotacoesServicos.obterSaldoProjetoAcao(
                this.rateio.codUnidade,
                this.rateio.codProjeto,
                this.rateio.codAcao,
                ano,
                mes
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.saldoProjetoAcao = response.data
                        this.mostrarSaldoProjetoAcao()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        mostrarSaldoProjetoAcao() {
            this.$swal({
                title: 'Saldo do Projeto/Ação',
                html: `(${this.rateio.codUnidade}) ${this.rateio.unidade} | (${
                    this.rateio.codProjeto
                }) ${this.rateio.projeto} | (${this.rateio.codAcao}) ${
                    this.rateio.acao
                }<br/><br/><strong><h3>${this.saldoProjetoAcao.toLocaleString(
                    'pt-br',
                    { style: 'currency', currency: 'BRL' }
                )}</h3></strong>`,
                icon: 'info',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Fechar'
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
